export default __webpack_public_path__ + "static/backgroundArchive-0a44cd7837e2459dcb4d136323f0c91d.webp";